import { PageProps } from 'gatsby'
import { ReactNode } from 'react'

import Page from '@/composites/Page'

import * as styles from './styles.module.css'

interface IBlogLayoutProps {
  children?: ReactNode
  location?: PageProps['location']
}

const BlogLayout = ({ children }: IBlogLayoutProps) => {
  return (
    <Page>
      <div className={styles.layoutBlog}>{children}</div>
    </Page>
  )
}

export default BlogLayout
